import { Order } from "../../../../../Models/Order";
import { StepType } from "../../../../../Steps/Step/StepType";


export class Tasks
{
    constructor(public StepType: StepType, public Orders: Order[]) { }
}
